<template>
  <v-card
    tile
    flat
    height="100%"
    style="position: relative"
    :style="{ 'background-color': '#e7e7e7' }"
    :class="`flexcard ma-0 pa-0`"
  >
    <!-- 헤더 START -->
    <rs-survey-header :themeColor="theme ? theme.color : null" :headerLogo="theme ? theme.headerLogo: null"></rs-survey-header>
    <v-progress-linear
    v-if="surveyResponse && surveyResponse.progressStatus == 'IN_PROGRESS'"
      :value="surveyResponse.progressRate"
      height="25"
      class="elevation-3"
    >
      <strong>{{ Math.ceil(surveyResponse.progressRate) }}%</strong>
    </v-progress-linear>
    <!-- 헤더 END -->
    <!-- 로딩 혹은 처리 중 표시 영역 START -->
    <v-overlay :value="loading" color="black" opacity="0.65">
      <rx-spinner
        spinnerType="CUBESHADOW"
        size="5rem"
        :message="$t('로딩중...')"
      >
      </rx-spinner>
    </v-overlay>
    <!-- 로딩 혹은 처리 중 표시 영역 END -->
    <!-- 메인 정보 영역 START -->
    <v-row justify="center">
      <v-col
        :class="`${$vuetify.breakpoint.smAndDown ? ' ma-2 col-12' : 'col-6'}`"
      >
        <v-fade-transition mode="out-in" origin="bottom center 0">
          <!-- 상태와 페이지를 조합한 key로 컴포넌트를 구분해 페이지 변경 시 새로 생성되도록 함 -->
          <component
            v-if="pageComp"
            :is="pageComp.component"
            :properties="pageComp.properties"
            @loading="(l) => (loading = l)"
            :rid="rid"
            :targetKey="targetKey"
            @next="nextPage"
            @previous="moveToPreviousPage"
            :key="`${surveyResponse.progressStatus}-${surveyResponse.currentPageId}`"
            :pagePath="pagePath"
            is-preview
            :themeColor="theme.color"
          ></component>
        </v-fade-transition>
      </v-col>
    </v-row>
    <!-- 메인 정보 영역 END -->
    <!-- 설문 안내 박스 START (설문 진행 이외 설문 진행 안내 페이지 정보) -->
    <v-fade-transition mode="out-in" origin="bottom center 0">
      <rs-survey-info
        v-show="isError"
        :message="isError.messageDetail"
      ></rs-survey-info>
    </v-fade-transition>
    <!-- 설문 안내 박스 END -->
  </v-card>
</template>
<script>
import { $getCurrentPreviewPage, $getSurveyTheme } from "@/redsurvey/api/survey";
import RsSurveyHeader from "@/redsurvey/components/survey/RsSurveyHeader";
import RsSurveyInfo from "@/redsurvey/components/common/RsSurveyInfo";
export default {
  components: {
    RsSurveyHeader,
    RsSurveyInfo,
  },
  props: {
    surveyId: {
      type: Number,
      required: true,
    },
    targetKey: {
      type: String,
    },
  },
  computed: {
    rid() {
      return localStorage.getItem("rsx:r");
    },
    infoMessage() {
      return null;
    },
  },
  data() {
    return {
      currentSurvey: {},
      survey: null,
      surveyResponse: null,
      isError: false,
      loading: false,
      pageComp: null,
      progressStatus: null,
      pagePath: [],
      theme: null,
    };
  },
  methods: {
    async init() {
      /**
       * 초기화
       */
      // 0 . theme 설정 처리 
      await this.setSurveyTheme();
      
      this.moveCurrentPage();
    },
    nextPage(progressStatus, nextPage) {
      if(progressStatus) {
        this.progressStatus = progressStatus;
      }
      if (progressStatus && progressStatus == "COMPLETED") {
        this.pageComp = {
          component: () =>
            import("@/redsurvey/components/survey/RsSurveyCompleted"),
          properties: null,
        };
      } else {
        this.moveCurrentPage(nextPage);
      }
    },
    moveToPreviousPage() {
      // 메모리의 페이지 이동 경로를 기준으로 이전 화면 조회
      if (this.surveyResponse.progressStatus == "WAIT_SUBMIT") {
        // 제출 대기 화면은 경로에 없으므로 마지막 실제 화면을 유지
        const previousPageId = this.pagePath[this.pagePath.length - 1];
        this.progressStatus = "IN_PROGRESS";
        this.moveCurrentPage(String(previousPageId), previousPageId);
      } else if (this.pagePath.length > 1) {
        // 진행 중인 화면은 현재 화면을 제거한 뒤 앞 화면으로 이동
        this.pagePath.pop();
        const previousPageId = this.pagePath[this.pagePath.length - 1];
        this.progressStatus = "IN_PROGRESS";
        this.moveCurrentPage(String(previousPageId), previousPageId);
      }
    },
    async moveCurrentPage(nextPage, currentPageId) {
      const params = {
        k: this.targetKey,
        r: this.rid,
        progressStatus: this.progressStatus,
        currentPageId: currentPageId !== undefined
          ? currentPageId
          : this.surveyResponse ? this.surveyResponse.currentPageId : null,
        nextPage: nextPage ? nextPage : null
      };
      try {
        this.loading = true;
        const { data } = await $getCurrentPreviewPage(this.surveyId, params);
        const rst = data.result;
        this.survey = rst.survey;
        this.surveyResponse = rst.surveyResponse;
        if (this.surveyResponse.progressStatus == "IN_PROGRESS") {
          // 진행 중인 화면만 미리보기 경로에 추가
          const currentPageId = this.surveyResponse.currentPageId;
          if (
            this.pagePath.length == 0 ||
            this.pagePath[this.pagePath.length - 1] != currentPageId
          ) {
            this.pagePath.push(currentPageId);
          }
        }
        switch (this.surveyResponse.progressStatus) {
          case "OPEN":
            this.pageComp = {
              component: () =>
                import("@/redsurvey/components/survey/RsSurveyStart"),
              properties: rst,
            };
            break;
          case "IN_PROGRESS":
            this.pageComp = {
              component: () =>
                import("@/redsurvey/components/survey/RsSurveyForm"),
              properties: rst,
            };
            break;
          case "WAIT_SUBMIT":
            this.pageComp = {
              component: () =>
                import("@/redsurvey/components/survey/RsSurveySubmit"),
              properties: rst,
            };
            break;
          default:
            break;
        }

        this.isError = false;
      } catch (e) {
        const err = e.response.data;
        this.isError = err;
      } finally {
        this.loading = false;
      }
    },
     //설문테마 정보 
    async setSurveyTheme() {
      try {
        const {data} = await $getSurveyTheme(this.surveyId);
        this.theme = data.result;
        } catch (e) {
        const err = e.response.data;
        this.isError = err;
      }
    }
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
  // background-color: rgb(68, 89, 158);
}
.flexcard {
  display: flex;
  flex-direction: column;
}
// Add the css below if your card has a toolbar, and if your toolbar's height increases according to the flex display.
.flexcard .v-toolbar {
  flex: 0;
}
</style>